import { BaseRestAPIService } from "@/services/base-rest-api.service";

export class SmsService extends BaseRestAPIService {
  constructor() {
    super(`sms`);
  }

  async check() {
    try {
      const response = await fetch(this.apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(await this.getHttpRequestOptions()),
        },
      });
      return response.status;
    } catch (e) {
      console.log("Failed to check SMS service", e);
    }
  }

  async sendSms(phoneNumber: string): Promise<void> {
    try {
      const response = await fetch(`${this.apiUrl}/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(await this.getHttpRequestOptions()),
        },
        body: JSON.stringify({ phoneNumber }),
      });
      return await response.json();
    } catch (e) {
      console.log("Failed to send SMS code", e);
    }
  }

  async verifyCode(code: string): Promise<boolean> {
    try {
      const response = await fetch(`${this.apiUrl}/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(await this.getHttpRequestOptions()),
        },
        body: JSON.stringify({ code }),
      });
      const result = await response.json();
      console.log("SMS code verification result:", result);
      return result.verified;
    } catch (e) {
      console.log("Failed to verify SMS code", e);
      return false;
    }
  }
}
